import { render, staticRenderFns } from "./UpdateALanguageManager.vue?vue&type=template&id=62b35c6a"
import script from "./UpdateALanguageManager.vue?vue&type=script&lang=js"
export * from "./UpdateALanguageManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports